import addFormats from "ajv-formats"
import addDraftFormats from "ajv-formats-draft2019";
import type Ajv from "ajv";

export function applyFormats(ajv: Ajv): Ajv {
  addFormats(ajv);
  addDraftFormats(ajv);
  return ajv;
}
